var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",[_c('AxButton',{on:{"click":function($event){return _vm.$emit('save')}}},[_vm._v(" "+_vm._s(_vm.$t('shared.save'))+" ")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }